import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import {
  messages
} from './components/common/i18n'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css'
import './components/common/directives'
import 'babel-polyfill'
import axios from 'axios' // 引入axios
import httpRequest from '../utils/request.js'
import globalMethod from './common/api/globalMethod.js'
import globalMap from '@/common/api/globalMap.js'
import Cookies from 'js-cookie'
import * as socketApi from './common/api/socket.js'
import storeInfo from './common/store/index.js'
import store from './store/'
import {
  Message, Loading
} from 'element-ui'

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(ElementUI, {
  size: 'small'
})
const i18n = new VueI18n({
  locale: 'zh',
  messages
})
// router.beforeEach((to, from, next) => {
//   /* 路由发生变化修改页面title */
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   next()
// })
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let isLogin = Cookies.get('userId')
  if (isLogin && localStorage.getItem('user_info')) {
    dealRoute(to.path, next)
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // globalMethod.showLogInvalidError()
      next({
        path: '/login' // 没有cookie登录信息路由跳转到登录页
        // query:{} // 登录成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      })
    }
  }
})
// //使用钩子函数对路由进
Vue.prototype.globalMethod = globalMethod
// axios.interceptors.request.use(config => {
//   // Loading.service({text:"Loading..."});
//   return config
//   // 在请求拦截里，可以做一些事情，也可以不做，不需要的话，暂时不要管这句话
//   return config
// }, error => {
//   Promise.reject(error)
// })
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch((error) => error)
// }
axios.defaults.timeout = 1000 * 60 * 10
//
// Vue.prototype.$http = httpRequest
// // response 拦截器
Vue.prototype.axios = httpRequest // 全局注册,任何组件都能直接使用
Vue.prototype.globalMap = globalMap
Vue.prototype.Cookies = Cookies
Vue.config.productionTip = false
// Vue.use(iView) // 使用iview组件
// Vue.use(Router)
// Vue.use(CKEditor)
// Vue.use(vhighcharts, {Highcharts})
Vue.prototype.socketApi = socketApi
Vue.prototype.storeInfo = storeInfo
// axios.interceptors.response.use(response => {
//   // 状态码填写
//   if (response.status === 200) {
//     // Loading.service().close();
//     let config = response.config.responseConfig || {}
//     if (response.config.responseType === 'blob') {
//       return response.data
//     }
//     if (response.data.success) {
//       if (config.destroySuccessMessage !== false || config.destroyMessage) {
//         Vue.prototype.globalMethod.destroyShow()
//       }
//       if (config.showSuccess || config.showAlert) {
//         Vue.prototype.globalMethod.showSuccess(config.successMessage || response.data.msg || '操作成功')
//       }
//       if (config.returnResponse) {
//         return response
//       }
//       return response.data
//     } else {
//       if (config.destroyFailMessage !== false || config.destroyMessage) {
//         Vue.prototype.globalMethod.destroyShow()
//       }
//       if (config.showError || config.showAlert || config.showError === undefined) {
//         Vue.prototype.globalMethod.showError(config.errorMessage || response.data.msg || '操作失败')
//       }
//       if (config.failCallback) {
//         config.failCallback(response.data)
//       }
//       return Promise.reject(response.data)
//     }
//   }
// }, error => {
//   // Loading.service().close();
//   let returnResponse = {
//     success: false,
//     entity: null,
//     msg: null,
//     response: error.response
//   }
//   if (error.response) {
//     Vue.prototype.globalMethod.destroyShow()
//     switch (error.response.status) {
//       case 401:
//         // 返回 401 清除token信息并跳转到登录页面
//         // store.commit(types.LOGOUT);
//         // globalMethod.showLogInvalidError()
//         globalMethod.destroyUser(router)
//         break
//       case 504:
//         Vue.prototype.globalMethod.showError('网关错误')
//         break
//       case 404:
//         Vue.prototype.globalMethod.showError('找不到该服务')
//         break
//       default:
//         let msg = '操作失败'
//         if (error.response.data && error.response.data.msg) {
//           msg = error.response.data.msg
//         }
//         Vue.prototype.globalMethod.showError(msg)
//     }
//   } else {
//     Vue.prototype.globalMethod.destroyShow()
//     Vue.prototype.globalMethod.showError('访问系统超时，请检查网络')
//   }
//   return Promise.reject(returnResponse) // 返回接口返回的错误信息
// })
const whiteList = ['/', '/register', '/login'] // 不重定向白名单
const dealRoute = function (url, next) {
  const fullPathList = url.split('/')
  let hasRole = false
  if (fullPathList.length > 1) {
    // const operationRoleData = globalMap.operationRoleMap[fullPathList[1]]
    let userRoleInfoStr = localStorage.getItem('user_info')
    if (userRoleInfoStr) {
      // const userRoleInfo = JSON.parse(localStorage.getItem('user_info'))
      // hasRole = !operationRoleData || (userRoleInfo && operationRoleData.urlRole.indexOf(userRoleInfo.roles[0].roleCode) > -1)
      hasRole = true
    }
    if (hasRole) {
      next()
    } else {
      // globalMethod.showError('页面不存在')
      globalMethod.reWriteUrl(next, 'next')
    }
  }
}

// 为IE中加入dataset属性
if (window.HTMLElement) {
  if (Object.getOwnPropertyNames(HTMLElement.prototype).indexOf('dataset') === -1) {
    Object.defineProperty(HTMLElement.prototype, 'dataset', {
      get: function () {
        const attributes = this.attributes // 获取节点的所有属性
        let name = []
        let value = [] // 定义两个数组保存属性名和属性值
        let obj = {} // 定义一个空对象
        for (let i = 0; i < attributes.length; i++) {
          // 遍历节点的所有属性
          if (attributes[i].nodeName.slice(0, 5) === 'data-') {
            // 如果属性名的前面5个字符符合"data-"
            // 取出属性名的"data-"的后面的字符串放入name数组中
            name.push(attributes[i].nodeName.slice(5))
            // 取出对应的属性值放入value数组中
            value.push(attributes[i].nodeValue)
          }
        }
        for (let j = 0; j < name.length; j++) {
          // 遍历name和value数组
          obj[name[j]] = value[j] // 将属性名和属性值保存到obj中
        }
        return obj // 返回对象
      }
    })
  }
}
// window.requestAnimationFrame多浏览器兼容问题补丁
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
// MIT license
// IE9不兼容requestAnimationFrame
(function () {
  let lastTime = 0
  let vendors = ['ms', 'moz', 'webkit', 'o']
  for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame']
  }
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callbackFun, element) {
      let currTime = new Date().getTime()
      let timeToCall = Math.max(0, 16 - (currTime - lastTime))
      let id = setTimeout(function () {
        callbackFun(currTime + timeToCall)
      }, timeToCall)
      lastTime = currTime + timeToCall
      return id
    }
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id)
    }
  }
})()
if (!('classList' in document.documentElement)) {
  Object.defineProperty(HTMLElement.prototype, 'classList', {
    get: function () {
      const self = this

      function update (fn) {
        return function (value) {
          let classes = self.className.split(/\s+/g)
          let index = classes.indexOf(value)
          fn(classes, index, value)
          self.className = classes.join(' ')
        }
      }

      return {
        add: update(function (classes, index, value) {
          if (!~index) classes.push(value)
        }),
        remove: update(function (classes, index) {
          if (~index) classes.splice(index, 1)
        }),
        toggle: update(function (classes, index, value) {
          if (~index) {
            classes.splice(index, 1)
          } else {
            classes.push(value)
          }
        }),
        contains: function (value) {
          return !!~self.className.split(/\s+/g).indexOf(value)
        },
        item: function (i) {
          return self.className.split(/\s+/g)[i] || null
        }
      }
    }
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  components: {
    App
  },
  template: '<App/>',
  i18n,
  render: h => h(App)
})

// new Vue({
//     router,
//     i18n,
//     render: h => h(App)
// }).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js